const accordionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5.4C0 4.6268 0.648415 4 1.44828 4H19.5517C20.3516 4 21 4.6268 21 5.4C21 6.1732 20.3516 6.8 19.5517 6.8H1.44828C0.648416 6.8 0 6.1732 0 5.4Z"
      fill="#6B00DF"
    />
    <path
      d="M0 11C0 10.2268 0.648415 9.6 1.44828 9.6H19.5517C20.3516 9.6 21 10.2268 21 11C21 11.7732 20.3516 12.4 19.5517 12.4H1.44828C0.648416 12.4 0 11.7732 0 11Z"
      fill="#6B00DF"
    />
    <path
      d="M0 16.6C0 15.8268 0.648415 15.2 1.44828 15.2H19.5517C20.3516 15.2 21 15.8268 21 16.6C21 17.3732 20.3516 18 19.5517 18H1.44828C0.648416 18 0 17.3732 0 16.6Z"
      fill="#6B00DF"
    />
  </svg>
);

export { accordionIcon };
